module.exports = __webpack_public_path__ + "static/nathan-61067e4a5f01cec14d8142c94366dad2.jpg";